var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "join-row-wrap"
  }, [_c('div', {
    staticClass: "join-row join-row--form"
  }, [_vm._m(0), _c('div', {
    staticClass: "join-table",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('form-row', {
    attrs: {
      "title": "아이디",
      "inputProps": {
        name: 'username'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.username,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  }), _c('form-row', {
    attrs: {
      "title": "비밀번호",
      "inputProps": {
        name: 'password',
        type: 'password'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  }, [_c('small', {
    staticClass: "text-grey text-grey--right"
  }, [_vm._v("(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)")])]), _c('form-row', {
    attrs: {
      "title": "비밀번호 확인",
      "inputProps": {
        name: 'password2',
        type: 'password'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.passwordConfirm,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "passwordConfirm", $$v);
      },
      expression: "user.passwordConfirm"
    }
  }), _c('form-row', {
    attrs: {
      "title": "기업명",
      "inputProps": {
        name: 'companyName'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "companyName", $$v);
      },
      expression: "user.companyName"
    }
  }), _c('form-row', {
    attrs: {
      "title": "대표자명",
      "inputProps": {
        name: 'ceoName'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "ceoName", $$v);
      },
      expression: "user.ceoName"
    }
  }), _c('form-row', {
    attrs: {
      "title": "기업설립일"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "type": "date",
      "name": "establishedAt",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.establishedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "establishedAt", $$v);
      },
      expression: "user.establishedAt"
    }
  })], 1), _c('form-row', {
    attrs: {
      "title": "사업자등록번호",
      "inputProps": {
        name: 'businessNumber',
        maxlength: '10'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.businessNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "businessNumber", $$v);
      },
      expression: "user.businessNumber"
    }
  }), _c('form-row', {
    attrs: {
      "title": "연락처"
    }
  }, [_c('div', {
    staticClass: "form-tel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone1,
      expression: "user.phone1"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "phone1", $event.target.value);
      }, _vm.input]
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone2,
      expression: "user.phone2"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone2
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "phone2", $event.target.value);
      }, _vm.input]
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone3,
      expression: "user.phone3"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone3
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "phone3", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('form-row', {
    attrs: {
      "title": "이메일"
    }
  }, [_c('div', {
    staticClass: "form-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email1,
      expression: "user.email1"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "email1"
    },
    domProps: {
      "value": _vm.user.email1
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "email1", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("@")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email2,
      expression: "user.email2"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "email2"
    },
    domProps: {
      "value": _vm.user.email2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "email2", $event.target.value);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email3,
      expression: "user.email3"
    }],
    staticClass: "select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.user, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.email2 = _vm.user.email3;
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("직접입력")]), _c('option', {
    domProps: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    domProps: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    domProps: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])]), _c('form-row', {
    attrs: {
      "title": "주소"
    }
  }, [_c('div', {
    staticClass: "form-address"
  }, [_c('div', {
    staticClass: "form-address__postcode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.postcode,
      expression: "user.postcode"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "우편번호",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.postcode
    },
    on: {
      "click": _vm.onSearchPostcode,
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "postcode", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "button button--primary",
    on: {
      "click": _vm.onSearchPostcode
    }
  }, [_vm._v("검색")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.address1,
      expression: "user.address1"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "기본주소",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.address1
    },
    on: {
      "click": _vm.onSearchPostcode,
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "address1", $event.target.value);
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.address2,
      expression: "user.address2"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "상세주소"
    },
    domProps: {
      "value": _vm.user.address2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "address2", $event.target.value);
      }
    }
  })])]), _c('form-row', {
    attrs: {
      "title": "관심분야"
    }
  }, _vm._l(_vm.areas, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child) {
      return _c('v-row', {
        key: child._id
      }, [_c('v-col', [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "label": child.name,
          "value": child._id,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "input": _vm.input
        },
        model: {
          value: _vm.user._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.user, "_areas", $$v);
          },
          expression: "user._areas"
        }
      })], 1), child.name == '기타(입력)' && _vm.user._areas.includes(child._id) ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        staticClass: "my-0 py-0",
        attrs: {
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: _vm.user.areas_manual[parent._id],
          callback: function callback($$v) {
            _vm.$set(_vm.user.areas_manual, parent._id, $$v);
          },
          expression: "user.areas_manual[parent._id]"
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  }), 1)], 1)])]), _c('div', {
    staticClass: "join-row-wrap"
  }, [_vm._m(1), _c('div', {
    staticClass: "join-table",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('form-row', {
    attrs: {
      "title": "홈페이지 주소",
      "inputProps": {
        name: 'website'
      }
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.website,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "website", $$v);
      },
      expression: "user.website"
    }
  }), _c('form-row', {
    attrs: {
      "title": "담당자정보"
    }
  }, [_c('div', {
    staticClass: "row row--small"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerName", $$v);
      },
      expression: "user.workerName"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "placeholder": "직책",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerTitle", $$v);
      },
      expression: "user.workerTitle"
    }
  })], 1)])]), _c('form-row', {
    attrs: {
      "title": "주요생산제품"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.mainProduct,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "mainProduct", $$v);
      },
      expression: "user.mainProduct"
    }
  }), _c('form-row', {
    attrs: {
      "title": "기업개요"
    }
  }, [_c('v-textarea', {
    staticClass: "rounded-0",
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "summary", $$v);
      },
      expression: "user.summary"
    }
  })], 1), _c('form-row', {
    attrs: {
      "title": "기업로고"
    }
  }, [_c('v-file-input', {
    staticClass: "rounded-0",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "accept": "image/*"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.avatar,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "avatar", $$v);
      },
      expression: "user.avatar"
    }
  })], 1), _c('form-files', {
    attrs: {
      "title": "소개자료"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.brochures,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "brochures", $$v);
      },
      expression: "user.brochures"
    }
  })], 1)])])]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('button', {
    staticClass: "button button--border-primary",
    on: {
      "click": function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', [_vm._v("취소하기")])]), _c('button', {
    staticClass: "button button--primary",
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_c('span', [_vm._v("회원가입")])])]), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.user.postcode = postcode;
        _vm.user.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("회원정보 필수입력")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("회원정보 선택입력")])]);
}]

export { render, staticRenderFns }